const formSubmitOnce = (isFormEl = true) => {
    const form = document.querySelector('form[data-submit-once]');
    let timer;

    if (!form) {
        return;
    }

    if (form.dataset.submitOnceForm) {
        isFormEl = true;
    }

    const listenedElement = isFormEl ? form : form.querySelector('[type="submit"]');
    const listenedEvent = isFormEl ? 'submit' : 'click';

    listenedElement.addEventListener(listenedEvent, (e) => {
        if (listenedEvent === 'submit' && form.hasOwnProperty('validateForm')) {
            if (!form.validateForm()) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
        }

        const {
            dataset: {
                formSubmitted = 'false'
            }
        } = form;

        if (formSubmitted === 'true') {
            e.preventDefault();
            e.stopPropagation();

            clearTimeout(timer);

            timer = setTimeout(() => {
                form.dataset.formSubmitted = 'false';
            }, 5000);
        }

        form.dataset.formSubmitted = form.reportValidity();
    });
};

export default formSubmitOnce;
